<template>
  <div id="infoCardTreeMap">
    <v-card>
      <v-card-title class="justify-left">
        <v-icon left>{{ icon }}</v-icon>
        <h4 class="font-weight-medium">{{ title }}</h4>
      </v-card-title>

      <v-card-text class="pt-0">
        <TreeMap :data="data_chart" :height="360" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import TreeMap from "../charts/TreeMap.vue";

export default {
  name: "InfoCardTreeMap",
  components: { TreeMap },
  props: {
    title: String,
    icon: String,
    data: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      data_chart: { serie: [], colors: [] },
    };
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        this.data_chart = this.transformData(val);
      },
    },
  },
  methods: {
    transformData(arr) {
      if (!Array.isArray(arr)) return { serie: [], colors: [] };

      const serie = arr
        .map((p) => {
          const y = this.parseProduccion(p.produccion);
          return {
            x: p.producto || p.x || "Producto",
            y,
            producto: p.producto,
            pertinencia: p.pertinencia,
            practica: p.practica,
            sellos: p.sellos,
            produccion: p.produccion,
          };
        })
        .filter((d) => !isNaN(d.y) && d.y > 0);

      const colors = [
        "#7CB342",
        "#F57C00",
        "#E53935",
        "#8BC34A",
        "#FFEB3B",
        "#5C6BC0",
        "#9C27B0",
        "#03A9F4",
        "#009688",
        "#795548",
      ];

      return { serie, colors: colors.slice(0, serie.length) };
    },
    parseProduccion(value) {
      if (!value) return 0;
      const num = parseFloat(
        value.toString().replace(",", ".").replace(/[^0-9.]/g, "")
      );
      return isNaN(num) ? 0 : num;
    },
  },
};
</script>

<style scoped>
.v-card-text {
  padding-top: 0 !important;
}
</style>
